<panel width="600">
  <h1>{{ 'sale.edit-order-installments.headline' | translate }}</h1>
  <section>
    @if (selectedInstallment) {
      <custom-select [allowAutoFocus]="false" [selectList]="availableInstallments" [(value)]="selectedInstallment" [required]="true" [label]="'order.edit-order-installments.select-installments' | translate" />
    }
    @if (selectedStartupInstallment) {
      <custom-select [allowAutoFocus]="false" [selectList]="availableInstallments" [(value)]="selectedStartupInstallment" [required]="true" [label]="'order.edit-order-installments.select-startup-installments' | translate" />
    }
  </section>
  <section>
    <button confirm (click)="save()">{{ 'general.save' | translate }}</button>
  </section>
</panel>
